<template>
    <nav aria-label="Page navigation example">
        <ul 
            v-if="pages.length > 1"
            class="pagination">
            <li v-if="displayPrev" class="page-item">
                <a class="page-link cursor-pointer" href="javascript:void(0);"
                    @click="openPage(value -1)" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>
            <li 
                v-for="p in pages" :key="p"
                :class="{
                    'page-item': true,
                    'active': value == p,
                    'cursor-pointer': value != p
                }">
                <a class="page-link" href="javascript:void(0);"
                    @click="openPage(p)">
                    {{p + 1}}
                </a>
            </li>
            <li class="page-item">
                <a v-if="displayNext" href="javascript:void(0);"
                    class="page-link cursor-pointer" 
                    @click="openPage(value + 1)" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>
        </ul>
    </nav>
</template>
<script>

export default{
    props: {
        numElements: Number,
        rowPerPage: Number,
        value: Number,
        maxVisiblePages: {
            type: Number,
            default: 5
        }
    },
    computed: {
        displayPrev(){
            return this.value > 0
        },
        displayNext(){
            let totalPages = Math.ceil( this.numElements / this.rowPerPage )
            return this.value + 1 < totalPages
        },
        pages(){
            let pages = []
            if (isNaN(this.numElements)){
                return pages
            }

            let totalPages = Math.ceil( this.numElements / this.rowPerPage )
            
            for (let i = this.value - 1; i >= 0 && pages.length < Math.floor(this.maxVisiblePages / 2); i--){
                pages.push(i )
            }
            pages.reverse()

            pages.push(this.value)

            for (let i = this.value + 1; i < totalPages && pages.length < this.maxVisiblePages; i++){
                pages.push(i)
            }

            return pages
        }
    },
    methods: {
        openPage(page){
            if (this.value == page){
                return
            }

            this.$emit('input', page)
        }
    }
}
</script>